var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "ui", staticClass: "box" },
    [
      _c(
        "el-container",
        {
          nativeOn: {
            click: function($event) {
              return _vm.handleClick($event)
            }
          }
        },
        [
          _c(
            "el-header",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.$store.state.hidden.menu,
                  expression: "$store.state.hidden.menu"
                }
              ],
              attrs: { height: "48px" }
            },
            [
              _c(
                "div",
                { staticClass: "my-div1" },
                [
                  _c(
                    "el-menu",
                    {
                      ref: "topMenu",
                      staticClass: "el-menu-demo",
                      attrs: {
                        "default-active": _vm.activeIndex,
                        mode: "horizontal",
                        "unique-opened": true,
                        "menu-trigger": "click",
                        router: false,
                        "background-color": _vm.backgroundcolor,
                        "text-color": _vm.textcolor,
                        "active-text-color": _vm.activetextcolor
                      },
                      on: { select: _vm.handleSelect, open: _vm.handleOpen }
                    },
                    [
                      _vm._l(_vm.DieselMenus, function(m) {
                        return _c(
                          "el-menu-item",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: m.visible && !_vm.showDiesel,
                                expression: "m.visible && !showDiesel"
                              }
                            ],
                            key: m.index,
                            attrs: { index: m.index }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.translateText("textMap.", m.label)) +
                                "\n          "
                            )
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.ReciprocatMenus, function(m) {
                        return _c(
                          "el-menu-item",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: m.visible && !_vm.showReciprocat,
                                expression: "m.visible && !showReciprocat"
                              }
                            ],
                            key: m.index,
                            attrs: { index: m.index }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.translateText("textMap.", m.label)) +
                                "\n          "
                            )
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.RotatingMenus, function(m) {
                        return _c(
                          "el-menu-item",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: m.visible && !_vm.showRotating,
                                expression: "m.visible && !showRotating"
                              }
                            ],
                            key: m.index,
                            attrs: { index: m.index }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.translateText("textMap.", m.label)) +
                                "\n          "
                            )
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.ManualMenus, function(m) {
                        return _c(
                          "el-menu-item",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: m.visible && !_vm.showManual,
                                expression: "m.visible && !showManual"
                              }
                            ],
                            key: m.index,
                            attrs: { index: m.index }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.translateText("textMap.", m.label)) +
                                "\n          "
                            )
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.WirelessMenus, function(m) {
                        return _c(
                          "el-menu-item",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: m.visible && !_vm.showWireless,
                                expression: "m.visible && !showWireless"
                              }
                            ],
                            key: m.index,
                            attrs: { index: m.index }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.translateText("textMap.", m.label)) +
                                "\n          "
                            )
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.ToCMenus, function(m) {
                        return _c(
                          "el-menu-item",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: m.visible && !_vm.showToC,
                                expression: "m.visible && !showToC"
                              }
                            ],
                            key: m.index,
                            attrs: { index: m.index }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.translateText("textMap.", m.label)) +
                                "\n          "
                            )
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.EscalatorMenus, function(m) {
                        return _c(
                          "el-menu-item",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: false && m.visible && !_vm.showEscalator,
                                expression:
                                  "false && m.visible && !showEscalator"
                              }
                            ],
                            key: m.index,
                            attrs: { index: m.index }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.translateText("textMap.", m.label)) +
                                "\n          "
                            )
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.FurnaceMenus, function(m) {
                        return _c(
                          "el-menu-item",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: m.visible && !_vm.showHeatingFurnace,
                                expression: "m.visible && !showHeatingFurnace"
                              }
                            ],
                            key: m.index,
                            attrs: { index: m.index }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.translateText("textMap.", m.label)) +
                                "\n          "
                            )
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.GasMenus, function(m) {
                        return _c(
                          "el-menu-item",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: m.visible && !_vm.showGas,
                                expression: "m.visible && !showGas"
                              }
                            ],
                            key: m.index,
                            attrs: { index: m.index }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.translateText("textMap.", m.label)) +
                                "\n          "
                            )
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.OfflineMenus, function(m) {
                        return _c(
                          "el-menu-item",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: m.visible && !_vm.showOffline,
                                expression: "m.visible && !showOffline"
                              }
                            ],
                            key: m.index,
                            attrs: { index: m.index }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.translateText("textMap.", m.label)) +
                                "\n          "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.showTopic
                ? _c(
                    "div",
                    { staticClass: "my-div" },
                    [
                      _c(
                        "el-menu",
                        {
                          ref: "topMenu1",
                          staticClass: "el-menu-demo",
                          attrs: {
                            "default-active": _vm.topiccolor,
                            mode: "horizontal",
                            "unique-opened": true,
                            "menu-trigger": "click",
                            "background-color": _vm.backgroundcolor,
                            "text-color": _vm.textcolor,
                            "active-text-color": _vm.activetextcolor
                          },
                          on: { select: _vm.handleTopic, open: _vm.handleOpen }
                        },
                        [
                          _c(
                            "el-submenu",
                            {
                              staticClass: "another_item",
                              attrs: { index: "9" }
                            },
                            [
                              _c("template", { slot: "title" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.translateText("textMap.", "更改主题")
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-menu-item",
                                { attrs: { index: "quiet-blue" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.translateText("textMap.", "静谧蓝")
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-menu-item",
                                { attrs: { index: "simple-white" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.translateText("textMap.", "默认")
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-menu-item",
                                { attrs: { index: "high-ash" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.translateText("textMap.", "暗黑")
                                    )
                                  )
                                ]
                              )
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showLanguage
                ? _c(
                    "div",
                    { staticClass: "my-div" },
                    [
                      _c(
                        "el-menu",
                        {
                          ref: "topMenu2",
                          staticClass: "el-menu-demo",
                          attrs: {
                            "default-active": _vm.language,
                            mode: "horizontal",
                            "unique-opened": true,
                            "menu-trigger": "click",
                            "background-color": _vm.backgroundcolor,
                            "text-color": _vm.textcolor,
                            "active-text-color": _vm.activetextcolor
                          },
                          on: { select: _vm.translateLan, open: _vm.handleOpen }
                        },
                        [
                          _c(
                            "el-submenu",
                            {
                              staticClass: "another_item",
                              attrs: { index: "9" }
                            },
                            [
                              _c("template", { slot: "title" }, [
                                _vm._v(
                                  _vm._s(_vm.translateText("textMap.", "语言"))
                                )
                              ]),
                              _vm._v(" "),
                              _c("el-menu-item", { attrs: { index: "zh" } }, [
                                _vm._v(
                                  _vm._s(_vm.translateText("textMap.", "中文"))
                                )
                              ]),
                              _vm._v(" "),
                              _c("el-menu-item", { attrs: { index: "en" } }, [
                                _vm._v(
                                  _vm._s(_vm.translateText("textMap.", "英文"))
                                )
                              ]),
                              _vm._v(" "),
                              _c("el-menu-item", { attrs: { index: "ru" } }, [
                                _vm._v(
                                  _vm._s(_vm.translateText("textMap.", "俄文"))
                                )
                              ])
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c("el-container", { staticClass: "content" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.$store.state.hidden.plantTree,
                    expression: "$store.state.hidden.plantTree"
                  }
                ],
                staticClass: "left-aside",
                attrs: { id: "leftAside" }
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showMenu,
                        expression: "showMenu"
                      }
                    ],
                    staticClass: "left-title"
                  },
                  [
                    _c("span", { staticClass: "left-title-txt" }, [
                      _vm._v(_vm._s(_vm.translateText("textMap.", "组织机构")))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showMenu,
                        expression: "showMenu"
                      }
                    ],
                    staticClass: "left-content",
                    style: { width: _vm.myWidth }
                  },
                  [
                    _c("PlantTree", {
                      ref: "plant",
                      staticClass: "trees",
                      on: {
                        handleMenuClose: _vm.handleClick,
                        updateRouter: _vm.updateRouter,
                        changeTopic: _vm.changeTopic,
                        NowEquid: _vm.ChangEquId,
                        fail: _vm.datafail
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "menu-hide" }, [
                  _vm.showMenu
                    ? _c(
                        "div",
                        {
                          staticClass: "op-btn",
                          on: { click: _vm.changeflag }
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass: "op-btn-svg",
                              staticStyle: { "flex-shrink": "0" },
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "10px",
                                height: "66px",
                                viewBox: "0 0 10 66",
                                fill: "none"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M0 0L10 8V58L0 66V0Z",
                                  fill: _vm.$store.state.leftconbgcolor
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "svg",
                            {
                              staticClass: "op-btn-svg",
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "10",
                                height: "10",
                                viewBox: "0 0 10 10",
                                fill: "none"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d:
                                    "M7.36623 1.72184V0.85912C7.36623 0.784343 7.28029 0.743048 7.22225 0.788807L2.191 4.71849C2.14826 4.75174 2.11367 4.79431 2.08987 4.84295C2.06608 4.8916 2.05371 4.94503 2.05371 4.99919C2.05371 5.05334 2.06608 5.10678 2.08987 5.15542C2.11367 5.20407 2.14826 5.24663 2.191 5.27988L7.22225 9.20957C7.28141 9.25533 7.36623 9.21403 7.36623 9.13925V8.27653C7.36623 8.22184 7.34056 8.16939 7.29815 8.13591L3.28029 4.99974L7.29815 1.86247C7.34056 1.82899 7.36623 1.77653 7.36623 1.72184Z",
                                  fill: _vm.$store.state.textcolor,
                                  "fill-opacity": "0.85"
                                }
                              })
                            ]
                          )
                        ]
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "op-btn",
                          on: { click: _vm.changeflag }
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass: "op-btn-svg",
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "10",
                                height: "66",
                                viewBox: "0 0 10 66",
                                fill: "none"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M0 0L10 8V58L0 66V0Z",
                                  fill: _vm.$store.state.leftconbgcolor
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "svg",
                            {
                              staticClass: "op-btn-svg",
                              staticStyle: { "flex-shrink": "0" },
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "10px",
                                height: "10px",
                                viewBox: "0 0 10 10",
                                fill: "none"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d:
                                    "M7.83147 4.71901L2.80022 0.789324C2.78708 0.778974 2.77128 0.772542 2.75464 0.770766C2.738 0.76899 2.7212 0.771944 2.70617 0.779286C2.69113 0.786629 2.67847 0.798063 2.66964 0.812276C2.66081 0.826489 2.65617 0.842904 2.65625 0.859636V1.72236C2.65625 1.77705 2.68192 1.8295 2.72433 1.86298L6.74219 5.00026L2.72433 8.13754C2.6808 8.17102 2.65625 8.22348 2.65625 8.27816V9.14089C2.65625 9.21566 2.74219 9.25696 2.80022 9.2112L7.83147 5.28151C7.87424 5.24816 7.90883 5.20549 7.93262 5.15675C7.95642 5.10802 7.96878 5.0545 7.96878 5.00026C7.96878 4.94603 7.95642 4.89251 7.93262 4.84377C7.90883 4.79504 7.87424 4.75237 7.83147 4.71901Z",
                                  fill: _vm.$store.state.textcolor,
                                  "fill-opacity": "0.85"
                                }
                              })
                            ]
                          )
                        ]
                      )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "main" },
              [
                _c(
                  "keep-alive",
                  { attrs: { max: "10" } },
                  [
                    _vm.$route.meta.keepAlive
                      ? _c("router-view", {
                          key: _vm.$route.fullPath,
                          on: {
                            changename: _vm.changeunitname,
                            dataloading: _vm.dataloading,
                            hideloading: _vm.hideloading,
                            datasuccess: _vm.datasuccess,
                            datafail: _vm.datafail,
                            datanull: _vm.datanull,
                            customTip: _vm.customTip,
                            brushdatanull: _vm.brushdatanull,
                            notEvent: _vm.notEvent,
                            notExitPoint: _vm.notExitPoint,
                            pointNull: _vm.pointNull,
                            tmpDataNull: _vm.tmpDataNull,
                            intervalError: _vm.intervalError,
                            setinfoname: _vm.setnowname,
                            showOpPage: _vm.setOpPage
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.$route.meta.keepAlive
                  ? _c("router-view", {
                      on: {
                        changename: _vm.changeunitname,
                        dataloading: _vm.dataloading,
                        datasuccess: _vm.datasuccess,
                        datafail: _vm.datafail,
                        datanull: _vm.datanull,
                        customTip: _vm.customTip,
                        notEvent: _vm.notEvent,
                        notExitPoint: _vm.notExitPoint,
                        pointNull: _vm.pointNull,
                        tmpDataNull: _vm.tmpDataNull,
                        intervalError: _vm.intervalError,
                        setinfoname: _vm.setnowname,
                        showOpPage: _vm.setOpPage
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "el-dialog",
                  {
                    attrs: {
                      title: _vm.translateText("textMap.", "请输入标注"),
                      top: _vm.upsHeight,
                      modal: false,
                      visible: _vm.$store.state.dialogVisible,
                      width: "20%"
                    },
                    on: {
                      "update:visible": function($event) {
                        return _vm.$set(
                          _vm.$store.state,
                          "dialogVisible",
                          $event
                        )
                      }
                    }
                  },
                  [
                    _c("el-input", {
                      attrs: { size: "mini" },
                      model: {
                        value: _vm.$store.state.upsInputValue,
                        callback: function($$v) {
                          _vm.$set(_vm.$store.state, "upsInputValue", $$v)
                        },
                        expression: "$store.state.upsInputValue"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      { attrs: { slot: "footer" }, slot: "footer" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini" },
                            on: {
                              click: function($event) {
                                _vm.$store.state.dialogVisible = false
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.translateText("textMap.", "取消"))
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function($event) {
                                _vm.$store.state.updateGraphicTextFlag = true
                                _vm.$store.state.dialogVisible = false
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.translateText("textMap.", "确定"))
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "load",
                staticClass: "data-loading",
                staticStyle: { display: "block" }
              },
              [
                _c("div", { staticClass: "loadingtext" }, [
                  _c("i", { staticClass: "el-icon-loading" }),
                  _vm._v("数据加载中...")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "fail",
                staticClass: "datafail",
                staticStyle: { display: "none" }
              },
              [
                _c("div", { staticClass: "failtext" }, [
                  _c("i", { staticClass: "el-icon-warning" }),
                  _vm._v("数据获取失败")
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", {
              ref: "customTip",
              staticClass: "customTip",
              staticStyle: { display: "none" }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "bearing-info" },
              [
                _c(
                  "el-dialog",
                  {
                    attrs: {
                      title: _vm.translateText("textMap.", "计算轴承"),
                      top: _vm.bearingInfoHeight,
                      modal: false,
                      visible: _vm.$store.state.showBearingDialogFlag,
                      width: "25%"
                    },
                    on: {
                      "update:visible": function($event) {
                        return _vm.$set(
                          _vm.$store.state,
                          "showBearingDialogFlag",
                          $event
                        )
                      }
                    }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        staticClass: "bearing-form",
                        attrs: { "label-position": "left" }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label:
                                _vm.translateText("textMap.", "轴承型号") + ":"
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: _vm.translateText(
                                    "textMap.",
                                    "请选择类型"
                                  ),
                                  filterable: "",
                                  size: "mini"
                                },
                                model: {
                                  value: _vm.BEARING_ID,
                                  callback: function($$v) {
                                    _vm.BEARING_ID = $$v
                                  },
                                  expression: "BEARING_ID"
                                }
                              },
                              _vm._l(_vm.$store.state.bearingInfoList, function(
                                item
                              ) {
                                return _c("el-option", {
                                  key: item.BEARING_ID,
                                  attrs: {
                                    label: item.BEARING_ID,
                                    value: item.BEARING_ID
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.translateText("textMap.", "转速") + ":"
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                size: "mini",
                                placeholder: _vm.translateText(
                                  "textMap.",
                                  "请输入数字"
                                )
                              },
                              on: { input: _vm.onInputNumber },
                              scopedSlots: _vm._u([
                                {
                                  key: "append",
                                  fn: function() {
                                    return [_vm._v("r/min")]
                                  },
                                  proxy: true
                                }
                              ]),
                              model: {
                                value: _vm.BEARING_REV,
                                callback: function($$v) {
                                  _vm.BEARING_REV = $$v
                                },
                                expression: "BEARING_REV"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "my-form-item-group" },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label:
                                    _vm.translateText("textMap.", "内圈") + ":"
                                }
                              },
                              [_c("span", [_vm._v(_vm._s(_vm.innerValue))])]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label:
                                    _vm.translateText("textMap.", "滚动体") +
                                    ":"
                                }
                              },
                              [_c("span", [_vm._v(_vm._s(_vm.rollingValue))])]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "my-form-item-group" },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label:
                                    _vm.translateText("textMap.", "外圈") + ":"
                                }
                              },
                              [_c("span", [_vm._v(_vm._s(_vm.outerValue))])]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label:
                                    _vm.translateText("textMap.", "保持架") +
                                    ":"
                                }
                              },
                              [_c("span", [_vm._v(_vm._s(_vm.cageValue))])]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label:
                                _vm.translateText("textMap.", "内圈特征频率") +
                                ":"
                            }
                          },
                          [
                            _c("span", [_vm._v(_vm._s(_vm.fi))]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.fi,
                                    expression: "fi"
                                  }
                                ]
                              },
                              [_vm._v(" HZ")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label:
                                _vm.translateText("textMap.", "外圈特征频率") +
                                ":"
                            }
                          },
                          [
                            _c("span", [_vm._v(_vm._s(_vm.fo))]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.fo,
                                    expression: "fo"
                                  }
                                ]
                              },
                              [_vm._v(" HZ")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label:
                                _vm.translateText(
                                  "textMap.",
                                  "滚动体特征频率"
                                ) + ":"
                            }
                          },
                          [
                            _c("span", [_vm._v(_vm._s(_vm.fe))]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.fe,
                                    expression: "fe"
                                  }
                                ]
                              },
                              [_vm._v(" HZ")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label:
                                _vm.translateText(
                                  "textMap.",
                                  "保持架特征频率"
                                ) + ":"
                            }
                          },
                          [
                            _c("span", [_vm._v(_vm._s(_vm.fc))]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.fc,
                                    expression: "fc"
                                  }
                                ]
                              },
                              [_vm._v(" HZ")]
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      { attrs: { slot: "footer" }, slot: "footer" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.getBearingInfo()
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.translateText("textMap.", "查询"))
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "event-info" },
              [
                _c(
                  "el-dialog",
                  {
                    style: {
                      "--dialog-bgcolor": _vm.$store.state.leftconbgcolor,
                      "--dialog-textcolor": _vm.dialogTextColor,
                      "--dialog-bordercolor": _vm.dialogBorderColor,
                      "--dialog-input-bordercolor": _vm.dialogBorderColor,
                      "--dialog-btncolor": _vm.$store.state.buttoncolor,
                      "--dialog-placeholder-color": _vm.dialogTextColor + "80",
                      "--dialog-focus-color": _vm.$store.state.buttoncolor,
                      "--dialog-divider-color": _vm.dialogBorderColor
                    },
                    attrs: {
                      title: _vm.translateText("textMap.", "基准数据信息"),
                      top: _vm.BenchmarkInformationHeight,
                      modal: true,
                      "close-on-click-modal": false,
                      visible: _vm.$store.state.showEventDialogFlag,
                      width: "50%"
                    },
                    on: {
                      "update:visible": function($event) {
                        return _vm.$set(
                          _vm.$store.state,
                          "showEventDialogFlag",
                          $event
                        )
                      }
                    }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "eventForm",
                        staticClass: "event-form",
                        attrs: {
                          "label-position": "left",
                          model: _vm.$store.state,
                          rules: _vm.eventFormRules
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label:
                                _vm.translateText("textMap.", "基准数据名称") +
                                ":",
                              prop: "eventName"
                            }
                          },
                          [
                            _c("el-input", {
                              style: {
                                backgroundColor: _vm.$store.state.inputbgcolor,
                                color: _vm.dialogTextColor,
                                borderRadius: "4px"
                              },
                              attrs: {
                                size: "default",
                                placeholder: _vm.translateText(
                                  "textMap.",
                                  "请输入基准数据名称"
                                )
                              },
                              model: {
                                value: _vm.$store.state.eventName,
                                callback: function($$v) {
                                  _vm.$set(_vm.$store.state, "eventName", $$v)
                                },
                                expression: "$store.state.eventName"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label:
                                _vm.translateText("textMap.", "采集时间") + ":"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                style: {
                                  color: _vm.dialogTextColor,
                                  fontSize: "14px",
                                  lineHeight: "30px"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      new Date(
                                        _vm.$store.state.postData.markTime
                                      ).toLocaleString()
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.translateText("textMap.", "转速") + ":"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                style: {
                                  color: _vm.dialogTextColor,
                                  fontSize: "14px",
                                  lineHeight: "30px"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$store.state.currentRev + " r/min"
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.translateText("textMap.", "备注") + ":"
                            }
                          },
                          [
                            _c("el-input", {
                              style: {
                                backgroundColor: _vm.$store.state.inputbgcolor,
                                color: _vm.dialogTextColor,
                                borderRadius: "4px",
                                resize: "vertical"
                              },
                              attrs: {
                                size: "default",
                                type: "textarea",
                                placeholder: _vm.translateText(
                                  "textMap.",
                                  "请输入备注信息"
                                ),
                                rows: "3",
                                maxlength: "100",
                                "show-word-limit": "",
                                "word-limit": { show: true }
                              },
                              model: {
                                value: _vm.$store.state.eventDescription,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.$store.state,
                                    "eventDescription",
                                    $$v
                                  )
                                },
                                expression: "$store.state.eventDescription"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "dialog-footer",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "el-button",
                          {
                            style: _vm.getDialogButtonStyle("cancel"),
                            attrs: { size: "small" },
                            on: { click: _vm.closeEventDialog }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.translateText("textMap.", "取消"))
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            style: _vm.getDialogButtonStyle("confirm"),
                            attrs: {
                              type: "primary",
                              loading: _vm.saveLoading,
                              disabled: _vm.saveLoading,
                              size: "small"
                            },
                            on: {
                              click: function($event) {
                                return _vm.saveChartParameter()
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.saveLoading
                                  ? _vm.translateText("textMap.", "保存中")
                                  : _vm.translateText("textMap.", "确定")
                              )
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16a761b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16a761b6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Page/menu.vue
// module id = null
// module chunks = 